import React from "react";

import { Button } from "@mui/material";
import InputSelectionComponent from "../Dashboard/Component/inputSelection";

import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import RadioButtonsGroup from "../../Component/UI/RadioGroup/RadioGroup";

const RADIO_OPTIONS = [
  {
    value: "Company/Brand",
    label: "Institution",
  },
  {
    value: "Product",
    label: "Program",
  },
];

const SITE_SUGGESTIONS = [
  { id: 1, name: "Reddit", value: "reddit.com" },
  { id: 2, name: "Facebook", value: "facebook.com" },
  { id: 3, name: "Quora", value: "quora.com" },
  { id: 4, name: "X", value: "x.com" },
  { id: 5, name: "LinkedIn", value: "linkedin.com" },
  { id: 6, name: "YouTube", value: "youtube.com" },
  { id: 7, name: "Trust Pilot", value: "trustpilot.com" },
  { id: 8, name: "Glassdoor", value: "glassdoor.com" },
  { id: 9, name: "Wikipedia", value: "wikipedia.org" },
];

const DashboardNav = ({
  selectedOptionShow,
  contentTypes,
  brandItems,
  selectedBrandItems,
  handleBrandCheckChange,
  handleProductCheckChange,
  selectedProductItems,
  productItems,
  isFirstTime,
  selectedPersona,
  handlePersonaCheckChange,
  personas,
  selectedGeographyItems,
  handleGeographyCheckChange,
  geography,
  selectedMarketItems,
  handleMarketCheckChange,
  markets,
  selectedLlmItems,
  handleLlmCheckChange,
  dbLlms,
  showData,
  isDone,
  handleClickShow,
  filterModalType,
  showNav = true,
  setSelectedOptionShow,
  categories,
  handleCategoryCheckChange,
  selectedCategory,
  selectedSiteSuggestions,
  handleSiteSuggestionsCheckChange,
  excludeBrandOwnedSources,
  handleExcludeBrandOwnedSourcesChange,
}) => {
  const handleTypeChange = (value) => {
    if (setSelectedOptionShow) {
      setSelectedOptionShow(value);
    }
  };
  return (
    <>
      <div>
        <RadioButtonsGroup
          options={RADIO_OPTIONS}
          selectedvalue={selectedOptionShow}
          onChange={handleTypeChange}
        />
      </div>

      <div className="customTabContent tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="nav-competition-tab"
        >
          <div className="row">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-briefcase"></i>
                </span>
                {selectedOptionShow === "Company/Brand" ? (
                  <InputSelectionComponent
                    options={brandItems}
                    selectedOptions={selectedBrandItems}
                    handleChange={handleBrandCheckChange}
                  // type="brand"
                  />
                ) : (
                  <InputSelectionComponent
                    options={productItems}
                    selectedOptions={selectedProductItems}
                    handleChange={handleProductCheckChange}
                  // type="product"
                  />
                )}
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedCategory}
                  handleChange={handleCategoryCheckChange}
                  options={categories}
                // type="category"
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedPersona}
                  handleChange={handlePersonaCheckChange}
                  options={personas}
                // type="persona"
                />
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedGeographyItems}
                  handleChange={handleGeographyCheckChange}
                  options={geography}
                  type="geography"
                />
              </div>
            </div>
          </div>
          <div className="row mt-1">

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedMarketItems}
                  handleChange={handleMarketCheckChange}
                  options={markets}
                  type="market"
                />
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-globe"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedSiteSuggestions || []}
                  handleChange={handleSiteSuggestionsCheckChange}
                  options={SITE_SUGGESTIONS}
                  type="site"
                />
              </div>
            </div>

            <div className="col-md-3 d-flex align-items-center">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="eliminateBrandContent"
                  checked={excludeBrandOwnedSources}
                  onChange={handleExcludeBrandOwnedSourcesChange}
                />
                <label className="form-check-label" htmlFor="eliminateBrandContent" style={{ marginLeft: '8px', marginBottom: 0 }}>
                  Eliminate brand content/posts
                </label>
              </div>
            </div>

            <div className="col-md-3 d-flex align-items-start">
              <Button
                disabled={!isDone}
                style={{
                  backgroundColor: "gainsboro",
                  borderColor: "gainsboro",
                  color: "black",
                  // textTransform: "capitalize",
                }}
                variant="contained"
                color={"secondary"}
                onClick={handleClickShow}
              >
                Get Conversations Data
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardNav;
